// Shared inline styles for the billing island's plan screens (PlanPicker, ChangePlan).
export const card = { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '26px 30px' };
export const h2 = { fontSize: 19, fontWeight: 750, margin: '0 0 8px' };
export const sub = { fontSize: 15, color: 'var(--muted)', lineHeight: 1.6, margin: '0 0 18px', maxWidth: '62ch' };
export const field = {
  width: '100%', padding: '14px 16px', borderRadius: 10, border: '1px solid var(--border)',
  background: 'var(--surface2)', color: 'var(--text)', fontSize: 16, outline: 'none', fontFamily: 'inherit',
};
export const primaryBtn = {
  padding: '12px 22px', borderRadius: 10, border: 'none', background: 'var(--accent)', color: 'var(--accent-ink)',
  fontSize: 15.5, fontWeight: 750, cursor: 'pointer', fontFamily: 'inherit',
};
export const ghostBtn = { ...primaryBtn, background: 'transparent', color: 'var(--text)', border: '1px solid var(--border)', fontWeight: 600 };
export const label = { display: 'block', fontSize: 14.5, color: 'var(--muted)', marginBottom: 9 };
export const mono = { fontFamily: "'JetBrains Mono', monospace", fontVariantNumeric: 'tabular-nums' };
export const note = { fontSize: 14.5, color: 'var(--muted)', lineHeight: 1.6, margin: '0 0 10px', maxWidth: '62ch' };
